import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58742041"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 w-full" }
const _hoisted_2 = { class: "flex flex-row items-end" }
const _hoisted_3 = { class: "w-1/12" }
const _hoisted_4 = { class: "w-11/12" }
const _hoisted_5 = { class: "w-11/12" }
const _hoisted_6 = { class: "flex flex-row items-start mt-8 h-full" }
const _hoisted_7 = { class: "w-1/12" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"w-11/12 h-full\" data-v-58742041><div class=\"w-11/12\" style=\"height:80%;\" data-v-58742041><div id=\"toolbar-container\" data-v-58742041><select class=\"ql-font\" data-v-58742041><option value=\"work-sans\" selected data-v-58742041>Work Sans</option><option value=\"helvetica\" data-v-58742041>Helvetica</option></select><select class=\"ql-header\" data-v-58742041><option value=\"1\" data-v-58742041></option><option value=\"2\" data-v-58742041></option><option value=\"3\" data-v-58742041></option><option value=\"4\" data-v-58742041></option><option selected data-v-58742041></option></select><button class=\"ql-bold\" data-v-58742041></button><button class=\"ql-italic\" data-v-58742041></button><button class=\"ql-underline\" data-v-58742041></button><button class=\"ql-strike\" data-v-58742041></button><button class=\"ql-script\" value=\"sub\" data-v-58742041></button><button class=\"ql-script\" value=\"super\" data-v-58742041></button><button class=\"ql-list\" value=\"ordered\" data-v-58742041></button></div><div id=\"text-editor\" data-v-58742041></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('proposal.content.paragraph.fields.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "default-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localTitle) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localTitle]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('proposal.content.paragraph.fields.text')), 1)
      ]),
      _hoisted_8
    ])
  ]))
}